import useApi from '../useApi';
import useApiEndpoints from 'src/context/useApiEndpoints';
import { buildQueryParams } from '../endpoints/queryParamsHelper';
import type { MasterPlanVersionObservation } from 'src/app/recovery/stowageRecovery';

interface MasterStowagePlanVersionResponse {
    masterPlanVersion: number;
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const isMasterStowagePlanVersionResponse = (value: unknown): value is MasterStowagePlanVersionResponse => {
    if (!isRecord(value)) {
        return false;
    }

    return (
        typeof value.masterPlanVersion === 'number' &&
        Number.isSafeInteger(value.masterPlanVersion) &&
        value.masterPlanVersion > 0
    );
};

const useGetActiveMasterPlanVersionApi = (): {
    getActiveMasterPlanVersion: (imoNumber: number) => Promise<MasterPlanVersionObservation | undefined>;
} => {
    const { apiEndpoints } = useApiEndpoints();
    const { getApiData } = useApi();

    const getActiveMasterPlanVersion = async (imoNumber: number): Promise<MasterPlanVersionObservation | undefined> => {
        // This metadata-only read deliberately avoids loading or replacing the
        // Stowage graph before recovery decides whether a reload is required.
        const result: unknown = await getApiData({
            endpoint: apiEndpoints['getMasterStowagePlanVersion'].url,
            queryParam: buildQueryParams({ imoNumber }),
            callInBackground: true,
            forceRefreshCache: true,
        });

        return isMasterStowagePlanVersionResponse(result) ? { masterPlanVersion: result.masterPlanVersion } : undefined;
    };

    return { getActiveMasterPlanVersion };
};

export default useGetActiveMasterPlanVersionApi;
